module.exports = {"530111001":"关上街道","530111002":"太和街道","530111003":"吴井街道","530111004":"金马街道","530111005":"小板桥街道","530111006":"官渡街道","530111007":"矣六街道","530111008":"六甲街道","530111009":"大板桥街道","530111010":"阿拉街道","530111402":"昆明经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530111.json
// module id = 2540
// module chunks = 0